// 微信支付宝扫码
const wxRoutes = Array.from({ length: 7 }, (_, i) => ({
  path: `payment/wx/index${i + 1}`,
  name: `payment/wx/Index${i + 1}`,
  component: () => import(`@/views/shopping/payment/wx/index${i + 1}.vue`)
}))
const branch1wxRoutes = Array.from({ length: 3 }, (_, i) => ({
  path: `payment/wx/branch1/index${i + 1}`,
  name: `payment/wx/branch1/Index${i + 1}`,
  component: () => import(`@/views/shopping/payment/wx/branch1/index${i + 1}.vue`)
}))
const branch2wxRoutes = Array.from({ length: 4 }, (_, i) => ({
  path: `payment/wx/branch2/index${i + 1}`,
  name: `payment/wx/branch2/Index${i + 1}`,
  component: () => import(`@/views/shopping/payment/wx/branch2/index${i + 1}.vue`)
}))

const zfbRoutes = Array.from({ length:7 }, (_, i) => ({
  path: `payment/zfb/index${i + 1}`,
  name: `payment/zfb/Index${i + 1}`,
  component: () => import(`@/views/shopping/payment/zfb/index${i + 1}.vue`)
}))
const branch1zfbRoutes = Array.from({ length:2 }, (_, i) => ({
  path: `payment/zfb/branch1/index${i + 1}`,
  name: `payment/zfb/Index${i + 1}`,
  component: () => import(`@/views/shopping/payment/zfb/branch1/index${i + 1}.vue`)
}))
const branch2zfbRoutes = Array.from({ length:3 }, (_, i) => ({
  path: `payment/zfb/branch2/index${i + 1}`,
  name: `payment/zfb/Index${i + 1}`,
  component: () => import(`@/views/shopping/payment/zfb/branch2/index${i + 1}.vue`)
}))

import paymentIndex from '@/views/shopping/payment/index'



export default {
  path: '/shopping',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
      {
        path: 'payment/index',
        name: 'paymentIndex',
        component: paymentIndex
      },
    // 微信支付宝扫码，开始
    ...wxRoutes,
    ...branch1wxRoutes,
    ...branch2wxRoutes,
    ...zfbRoutes,
    ...branch1zfbRoutes,
    ...branch2zfbRoutes,
    // 微信支付宝扫码，结束

  ],
};
